import { Board } from "@/types/board";
import { createContext } from "react";

export const initialClientBoardAccessContext = {
    goalsBoard: null as Board | null,
};

export const BoardAccessContext = createContext(
    initialClientBoardAccessContext,
);
